export const srcSet="__VITE_ASSET__C5GRi_UO__ 56w";export const width=56;export const height=56;export default{srcSet:srcSet,width:width,height:height};